import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getProfile } from '../service/RecruiterApi';
// import Loader from '../../StaticComponent/Loader';

function CandidateProfile(props) {
    let profileObj = {
        firstName: '',
        middleName: '',
        lastName: '',
        gender: '',
        mobile: '',
        alternateMobile: '',
        dob: '',
        email: '',
        house: '',
        street: '',
        city: '',
        area: '',
        country: '',
        state: '',
        pincode: '',
        portfolio: '',
        interviewSource: '',
        candidate_photo_url: '',
        job_source_name: '',
        father_occupation: '',
        father_salary: '',
        mother_occupation: '',
        mother_salary: '',
        current_location: '',
        native_location: '',
        siblings: [{ occupation: '', salary: '' }]
    };

    const [profileData, setProfileData] = useState(profileObj);
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        loadProfile();
    }, [props.profileData]);
    /**
     * PS_PR_12 & PS_PR_13 - With the help of props pass the Family Details and Location details
     *                         and bind it here
     */
    let loadProfile = async () => {
        try {
            var value = props.profileData;
            let profileObject = {
                firstName: value.first_name,
                middleName: value.middle_name,
                lastName: value.last_name,
                gender: value.gender,
                mobile: value.mobile_number,
                alternateMobile: value.alternate_mobile_number,
                dob: value.date_of_birth,
                email: value.email_id,
                house: value.house,
                street: value.street,
                city: value.city,
                area: value.area,
                country: value.country,
                state: value.state,
                pincode: value.pincode,
                portfolio: value.portfolio_link,
                interviewSource: value.interview_source || '',
                candidate_photo_url: value.candidate_photo_url,
                job_source_name: value.job_source_name,
                father_occupation: value.father_occupation || '',
                father_salary: value.father_salary || '',
                mother_occupation: value.mother_occupation || '',
                mother_salary: value.mother_salary || '',
                current_location: value.current_location || '',
                native_location: value.native_location || '',
                siblings: Array.isArray(value.siblings) && value.siblings.length > 0
                    ? value.siblings.map(sibling => ({
                        occupation: sibling.sibling_occupation || '',
                        salary: sibling.sibling_salary || ''
                    }))
                    : [{ occupation: '', salary: '' }]
            };
            setProfileData(profileObject);
        } catch (e) { }
    };
    const ahref = () => {
        window.open(`${profileData.portfolio}`, '_blank');
    };

    return (
        <div>
            <div className="row">
                {/*Content - Starts here */}
                <div className="col-md-12 mt-4">
                    <div className="card">
                        <div className="card-body p-4">
                            <div className="row">
                                <label className="font-16 semibold-text mb-3">Personal Details</label>
                                <div className="col-md-12 mb-3">
                                    <img
                                        src={
                                            profileData.candidate_photo_url
                                                ? profileData.candidate_photo_url
                                                : '/Images/logo-person-user-person-icon.jpg'
                                        }
                                        className="recruit-profile-size"
                                        alt="Profile image"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">First Name</label>

                                    <p className="recruit-label-clr regular-text mb-0">
                                        {/* {profileData.firstName == null || ""
                      ? "-"
                      : profileData.firstName} */}

                                        {profileData.firstName ? profileData.firstName : '-'}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Middle Name</label>

                                    <p className="recruit-label-clr regular-text mb-0">
                                        {/* {profileData.middleName == null || ""
                      ? "-"
                      : profileData.middleName} */}

                                        {profileData.middleName ? profileData.middleName : '-'}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Last Name</label>

                                    <p className="recruit-label-clr regular-text mb-0">
                                        {/* {profileData.lastName == null || "" ? "-" : profileData.lastName} */}
                                        {profileData.lastName ? profileData.lastName : '-'}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Date of Birth</label>
                                    <p className="recruit-label-clr regular-text mb-0">{moment(profileData.dob).format('L')}</p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Email ID</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {/* {profileData.email == null ? "-" : profileData.email} */}
                                        {profileData.email ? profileData.email : '-'}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Contact Number</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {/* {profileData.mobile == null ? "-" : profileData.mobile} */}
                                        {profileData.mobile ? profileData.mobile : '-'}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Alternate Contact Number</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {/* {profileData.alternateMobile == null
                      ? "-"
                      : profileData.alternateMobile} */}
                                        {profileData.alternateMobile ? profileData.alternateMobile : '-'}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <p className="form-label regular-text mb-3 recruit-summary-label">Gender</p>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.gender == null ? '-' : profileData.gender}
                                    </p>
                                </div>
                                <label className="font-16 semibold-text recruit-label-clr mb-4 mt-5">Address Details</label>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">House / Building</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.house == null ? '-' : profileData.house}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Road / Street / Lane</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.street == null ? '-' : profileData.street}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Area / Locality / Sub Division</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.area == null ? '-' : profileData.area}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Town / city / District</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.city == null ? '-' : profileData.city}
                                    </p>
                                </div>
                                <div className="col-md-4  mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Country</label>
                                    <p className="recruit-label-clr regular-text mb-0">{profileData.country == null ? '-' : 'India'}</p>
                                </div>
                                <div className="col-md-4  mt-4">
                                    <label className="form-label regular-text recruit-summary-label">State</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.state == null ? '-' : profileData.state}
                                    </p>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label className="form-label regular-text recruit-summary-label">Pincode</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.pincode == null ? '-' : profileData.pincode}
                                    </p>
                                </div>
                                <label className="font-16 semibold-text mb-4 mt-5">Additional Details</label>
                                <h1 className="form-label regular-text recruit-summary-label">Show us your work</h1>
                                <a target="_blank" className="recruit-work text-decoration-none" onClick={ahref}>
                                    {profileData.portfolio == null ? '-' : profileData.portfolio}
                                </a>
                                <div className="col-md-4  mt-4">
                                    <label className="form-label regular-text recruit-summary-label">How did you hear about us</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {profileData.job_source_name == null ? '-' : profileData.job_source_name}
                                    </p>
                                </div>
                                <label className="font-16 semibold-text recruit-label-clr mt-5">Family Details</label>
                                <label className="font-16 semibold-text family-font-change">Father Details</label>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Occupation</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {!profileData.father_occupation ? '-' : profileData.father_occupation}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Salary</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {!profileData.father_salary ? '-' : profileData.father_salary}
                                    </p>
                                </div>
                                <label className="font-16 semibold-text family-font-change">Mother Details</label>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Occupation</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {!profileData.mother_occupation ? '-' : profileData.mother_occupation}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Salary</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {!profileData.mother_salary ? '-' : profileData.mother_salary}
                                    </p>
                                </div>
                                {profileData.siblings && profileData.siblings.length > 0 ? (
                                    profileData.siblings.map((sibling, index) => (
                                        <div key={index}>
                                            <label className="font-16 semibold-text family-font-change">Sibling Details {index + 1}</label>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-label regular-text recruit-summary-label">Occupation</label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {sibling.occupation || '-'}
                                                    </p>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label regular-text recruit-summary-label">Salary</label>
                                                    <p className="recruit-label-clr regular-text mb-0">
                                                        {sibling.salary || '-'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="recruit-label-clr regular-text mb-0">-</p>
                                )}

                                <label className="font-16 semibold-text family-font-change">Location Details</label>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Native Location</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {!profileData.native_location ? '-' : profileData.native_location}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label regular-text recruit-summary-label">Current Location</label>
                                    <p className="recruit-label-clr regular-text mb-0">
                                        {!profileData.current_location ? '-' : profileData.current_location}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Content - Ends here */}
            </div>
        </div>
    );
}

export default CandidateProfile;
